__webpack_require__.p = "/react-stellar-burger/";